import { useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { PortfolioListRedesign } from "web_myplann/Portfolio/Components/Redesign/PortfolioListRedesign";
import { MyPlannTopBarRedesign } from "web_myplann/Shared/Components/Redesign/MyPlannTopBarRedesign";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";

export const StandalonePortfolioListRedesign: FC = () => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<MyPlannLayout
			disableContentPadding
			disableBottomPadding
			bgColor={theme.palette.grey[50]}
			topBarBgColor={theme.palette.background.paper}
			topBar={
				<MyPlannTopBarRedesign
					title={t(Resources.Portfolio.Titles.portfolio)}
				/>
			}
		>
			<PortfolioListRedesign hasPortfolioRight={false} />
		</MyPlannLayout>
	);
};
